/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessCodeModel } from '../../models/access-code-model';

export interface SessionAccessCodeConfigAccessCodeGet$Params {
  accessCode: string;
}

export function sessionAccessCodeConfigAccessCodeGet(http: HttpClient, rootUrl: string, params: SessionAccessCodeConfigAccessCodeGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<AccessCodeModel>> {
  const rb = new RequestBuilder(rootUrl, sessionAccessCodeConfigAccessCodeGet.PATH, 'get');
  if (params) {
    rb.path('accessCode', params.accessCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<AccessCodeModel>;
    })
  );
}

sessionAccessCodeConfigAccessCodeGet.PATH = '/Session/AccessCodeConfig/{accessCode}';
